
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class AbonelikIptalBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IptalBasvuruSave";
    super(baseUrl);
  }


  saveAbonelikIptalBasvuruSave(request: IptalBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new AbonelikIptalBasvuruAPI();
class IptalBasvuruSaveRequest {
    sicilKodu: number;
    basvuruTuruId: number;
    aboneNo: number;
    islemTuruKodu: number;
    sonEndeks: number;
    ibanNumarasi: string;
    captchaToken?: string;

    constructor(
        sicilKodu: number,
        basvuruTuruId: number,
        aboneNo: number,
        islemTuruKodu: number,
        sonEndeks: number,
        ibanNumarasi: string,
        captchaToken?: string
    ) {
        this.sicilKodu = sicilKodu;
        this.basvuruTuruId = basvuruTuruId;
        this.aboneNo = aboneNo;
        this.islemTuruKodu = islemTuruKodu;
        this.sonEndeks = sonEndeks;
        this.ibanNumarasi = ibanNumarasi;
        this.captchaToken = captchaToken;
    }
}
export { IptalBasvuruSaveRequest };